import EditVideoCategoryContainer from "../containers/EditVideoCategoryContainer";

const EditVideoCategoryPage = () => {
  return (
    <EditVideoCategoryContainer />
  );
};

export default EditVideoCategoryPage;
